import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Autoplay } from "swiper/modules";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
// import { useMediaQuery } from "react-responsive";

const skills = [
  { name: "HTML/CSS", level: 90 },
  { name: "JavaScript", level: 40 },
  { name: "React", level: 50 },
  { name: "Node.js", level: 40 },
  { name: "Rest API", level: 40 },
  { name: "TypeScript", level: 40 },
  { name: "Next.js", level: 30 },
  { name: "Git & GitHub", level: 30 },
  { name: "Responsive Design", level: 90 },
  { name: "Accessibility (a11y)", level: 50 },
  { name: "Team Leadership", level: 70 },
  { name: "Project Planning", level: 60 },
  { name: "Time Management", level: 70 },
  { name: "Communication", level: 80 },
  { name: "Problem Solving", level: 70 },
  { name: "Decision Making", level: 60 },
  { name: "Conflict Resolution", level: 60 },
  { name: "Delegation", level: 50 },
  { name: "Strategic Thinking", level: 60 },
];

const Skills = () => {
  //   const isDesktop = useMediaQuery({ query: "(min-width: 1224px)" });
  //   const isTablet = useMediaQuery({
  //     query: "(min-width: 768px) and (max-width: 1224px)",
  //   });
  //   const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  let circleSize = 95;

  //   if (isDesktop) {
  //     circleSize = 100;
  //   } else if (isTablet) {
  //     circleSize = 120;
  //   } else if (isMobile) {
  //     circleSize = 100;
  //   }
  return (
    <>
      <section className="intro-style-one space-y-top space-y-bottom" id="skills">
        <div className="container">
          <div className="row gy-5 gx-4">
            <div className="col-12 col-sm-12 col-md-5 col-lg-5">
              <div className="section-heading">
                <h2 style={{ color: "#fff" }}>My Skills </h2>
                <p style={{ color: "#fff" }}>
                  Skills are the building blocks of personal and professional
                  success. They're not just what you know, but what you can do
                  with what you know.
                </p>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-7 col-lg-7" id="portfolio">
              <Swiper
                className="swiper portfolio-slider"
                spaceBetween={30}
                breakpoints={{
                  1200: { slidesPerView: 3 },
                  768: { slidesPerView: 2 },
                  0: { slidesPerView: 2 },
                }}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                modules={[Autoplay]}
                loop={true}
              >
                {skills.map((skill, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="skillsTile"
                      style={{
                        width: `${circleSize}%`,
                        textAlign: "center",
                      }}
                    >
                      <CircularProgressbar
                        value={skill.level}
                        text={`${skill.level}%`}
                        styles={buildStyles({
                          pathColor: "#00BFFF",
                          textColor: "#333",
                          trailColor: "#eee",
                          pathTransitionDuration: 1.5,
                        })}
                      />
                      <p
                        style={{
                          marginTop: "10px",
                          textTransform: "uppercase",
                          fontWeight: 500,
                          fontSize: "13px",
                        }}
                      >
                        {skill.name}
                      </p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Skills;
